import React from 'react';

const PageActions = ({ pageActions }) => {
  return(
    <>
      { pageActions && pageActions.map((action, index) => {
        return <a href={ action.url } key={ index } className={ action.btnClass }>
          { action.label }
        </a>
      }) }
    </>
  )
}

export default PageActions;
